import apiClient from '@/services/axios'

// Get all tier levels
export const getTierLevels = () => {
    return apiClient.get('/tierlevels')
}

// Get a specific tier level by ID
export const getTierLevel = (id) => {
    return apiClient.get(`/tierlevels/${id}`)
}

// Create a new tier level
export const createTierLevel = (tierLevelData) => {
    return apiClient.post('/tierlevels', {
        tierLevelNumber: tierLevelData.tierLevelNumber,
        tierLevelName: tierLevelData.tierLevelName,
        tierLevelPointsRequirement: tierLevelData.tierLevelPointsRequirement,
        userTierLevelInfoLocalized: tierLevelData.userTierLevelInfoLocalized,
        membershipFeeOverrideEnabled: tierLevelData.membershipFeeOverrideEnabled,
        membershipFeeOverride: tierLevelData.membershipFeeOverride,
        fullDiscount: tierLevelData.fullDiscount,
        reducedDiscount: tierLevelData.reducedDiscount
    })
}

// Update an existing tier level
export const updateTierLevel = (id, tierLevelData) => {
    return apiClient.put(`/tierlevels/${id}`, {
        tierLevelNumber: tierLevelData.tierLevelNumber,
        tierLevelName: tierLevelData.tierLevelName,
        tierLevelPointsRequirement: tierLevelData.tierLevelPointsRequirement,
        userTierLevelInfoLocalized: tierLevelData.userTierLevelInfoLocalized,
        membershipFeeOverrideEnabled: tierLevelData.membershipFeeOverrideEnabled,
        membershipFeeOverride: tierLevelData.membershipFeeOverride,
        fullDiscount: tierLevelData.fullDiscount,
        reducedDiscount: tierLevelData.reducedDiscount,
        iconUrl: tierLevelData.iconUrl,
        color: tierLevelData.color
    })
}

// Delete a tier level
export const deleteTierLevel = (id) => {
    return apiClient.delete(`/tierlevels/${id}`)
}

// Update tier level perks only
export const updateTierLevelPerks = (id, perkConfigs) => {
    return apiClient.put(`/tierlevels/${id}/perk-configs`, {
        perkConfigs: perkConfigs.perkConfigs || [],
        levelReachedOnetimePerkConfigs: perkConfigs.levelReachedOnetimePerkConfigs || []
    })
}

export default {
    getTierLevels,
    getTierLevel,
    createTierLevel,
    updateTierLevel,
    deleteTierLevel,
    updateTierLevelPerks
} 